export interface Employee {
  name: string;
  userId: string;
  beginOfContract: string;
  lastDayOfContract: string | null;
  plannedMinutesPerDayList?: PlannedMinutesListEntry[];
  agreedVacationDays?: VacationDaysListEntry[];
}

export interface PlannedMinutesListEntry {
  startDate: string; // Date string
  minutesPerDay: number[]; // Minutes per day for each day of the week (Mon-Fri)
}

export interface VacationDaysListEntry {
  startDate: string; // Date string
  vacationDays: number; // Number of vacation days
}

export interface WorkStats {
  date: string;
  expectedMinutesWorked: number;
  totalMinutesWorked: number;
  vacationMinutes: number;
  sickMinutes: number;
  numberOfEntries: number;
}

export interface OvertimeStats {
  date: string;
  expectedMinutesWorked: number;
  totalMinutesWorked: number;
  overOrUnderTimeMinutes: number;
  sickMinutes: number;
  totalOverOrUndertime: number;
  availableVacationMinutes: number;
  usedVacationMinutes: number;
  plannedVacationMinutes: number;
  remainingVacationMinutes: number;
}

export interface HistoryEntry {
  date: string;
  value: any;
}

export enum VacationRequestStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED", 
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED"
}

export interface VacationRequest {
  id: number;
  employeeUserId: string;
  employeeName?: string;
  startDate: string;
  endDate: string;
  requestDate: string;
  status: VacationRequestStatus;
  approverUserId?: string;
  approverName?: string;
  approvalDate?: string;
  notes?: string;
  rejectionReason?: string;
  totalDays: number;
}

export interface OvertimePermission {
  id: number;
  employeeUserId: string;
  employeeName: string;
  startDate: string;
  endDate: string | null;
}